import React from 'react'
import { Link } from 'react-router-dom'

import { MenuEntry, MenuEntryProps } from '@procsea/design-system'

export interface MenuEntryLinkProps extends MenuEntryProps {
  to: string
  isVisible?: boolean
}

const MenuEntryLink = ({
  'data-e2e': dataE2e,
  count,
  icon,
  isActive,
  label,
  isVisible = true,
  onClick,
  to,
  variant,
}: MenuEntryLinkProps) =>
  isVisible ? (
    <Link data-e2e={`${dataE2e}--anchor`} to={to}>
      <MenuEntry
        count={count}
        data-e2e={dataE2e}
        icon={icon}
        label={label}
        isActive={isActive}
        onClick={onClick}
        variant={variant}
      />
    </Link>
  ) : null

export default MenuEntryLink
